export enum DiscountTypeEnum {
    amount='amount',
    percentage='percentage'
}